import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "statusColor", pure: false })
export class StatusColorPipe implements PipeTransform {
  statusToColor = {
    draft: "tertiary",
    open: "secondary",
    full: "primary",
    prepared: "primary",
    distributing: "primary",
    delivered: "primary",
    cancelled: "primary",
    closed: "primary",
    unpaid: "primary",
    paid: "tertiary",
    cashed: "secondary"
  };

  transform(status: string): string {
    console.log(this.statusToColor[status]);
    return this.statusToColor[status];
  }
}
